import React, {ReactElement, ReactNode, useCallback} from 'react'
import {FormSection} from "../../../common/components/SectionedForm";
import {api} from "../../../common/api";
import FormButtons from "../../../common/form/FormButtons";
import SpinnableSubmitButton from "../../../common/form/SpinnableSubmitButton";
import {useSelector} from "react-redux";
import {selectedSiteSelector} from "../../../authentication/redux";
import {useTranslation} from "react-i18next";
import PaperStack from "../../../common/form/PaperStack";
import FormGroup from "../../../common/form/FormGroup";
import {LabelValues, LabelValueType} from "../../../common/components/LabelValues";
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import {Supervisor, SupervisorWithSitesForm} from "../../../app/types";
import Form, {mapSupervisorToForm} from "../Form";
import {useHistory} from "react-router";

export const useGeneralSection = (executiveId: string, isFetching: boolean, error: any, refetch: () => void, data?: Supervisor) : FormSection<Supervisor> => {
    const { t } = useTranslation()
    const site = useSelector(selectedSiteSelector)
    const history = useHistory();

    const onGeneralSubmit = useCallback((onSucceeded: () => void) =>
            async (formData: SupervisorWithSitesForm) => {
                if (!site) return
                await api.put(`/api/site/${site.productId}/amcc/supervisors/${executiveId}`, {
                    superviseAllSites: formData.superviseAllSites,
                    supervisedSiteIds: formData.superviseAllSites ? [] : formData.supervisedSiteIds
                })
                await refetch()
                onSucceeded();
                history.push('/contact-center')
            },
        [site, executiveId, refetch, history],
    )

    const buildFormButtons = useCallback( (cancelEditButton: ReactElement) => (isSubmitting: boolean) =>
            <FormButtons buttons={[<SpinnableSubmitButton label={t('general.form-update')} showSpinner={isSubmitting} />, cancelEditButton]} fullWidth={true}/>
        , [t])

    const renderGeneralForm = useCallback((supervisor: Supervisor, cancelEditButton: ReactElement, onSucceeded: () => void): ReactNode => <Form supervisorForm={mapSupervisorToForm(supervisor)} buildFormButtons={buildFormButtons(cancelEditButton)}
                                                                                                                                              onSubmit={onGeneralSubmit(onSucceeded)} />, [onGeneralSubmit, buildFormButtons])

    const infoLabelValues = useCallback(
        (supervisor: Supervisor): LabelValueType[] => [
            {
                label: t('supervisors.supervised-sites'),
                value: <>{supervisor.superviseAllSites ? t('supervisors.all-sites') :
                        supervisor.supervisedSites.length > 0 ?
                            supervisor.supervisedSites.map(site => site.siteName).join(', ') :
                                t('general.none')}
                </>,
            },
        ],
        [t]
    )

    const renderDetails = useCallback(
        (supervisor: Supervisor): ReactNode => {
            return (
                <PaperStack>
                    {[<FormGroup key={1} label={''} fullWidth={true}>
                        <LabelValues labelValues={infoLabelValues(supervisor)} />
                    </FormGroup>]}
                </PaperStack>
            )
        },
        [infoLabelValues])

    return {
        title: t('supervisors.supervised-sites'),
        data: data,
        isFetching: isFetching,
        error: error,
        refetch: refetch,
        renderDetails: renderDetails,
        renderForm: renderGeneralForm,
        enabled: () => true,
        icon: () => <WhereToVoteIcon/>
    }
}